import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute, Params, NavigationEnd, NavigationStart } from '@angular/router';

import { Product } from '../../common/models/product';
import { PaymentStatus } from '../../common/models/paymentStatus';

import { PaymentService } from '../services/payment.service';
import { PaymentInformation } from '../../common/models/paymentInfo';
import { SessionManager } from '../../common/helpers/session-manager';
import { InvoiceService } from '../services/invoice.service';
import { Invoice } from '../../common/models/invoice';
import { EmailService } from '../../common/services/email.service';
import { AppLoggingService } from '../../common/services/AppLogging.service';
import { Localization } from '../../common/helpers/localization';

import * as moment from 'moment';
import 'moment/locale/pt-br';


@Component({
  selector: 'app-payment-receipt',
  templateUrl: './payment-receipt.component.html',
  styleUrls: ['./payment-receipt.component.css'],
})
export class PaymentReceiptComponent implements OnInit {

  @Input() productNamesString: string;
  @Input() dateString: string;
  @Input() paymentReceiptInfoObj: PaymentInformation;
  @Input() invoiceInfoObj: Invoice;

  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    private sessionManager: SessionManager,
    private invoiceService: InvoiceService,
    private emailService: EmailService,
    private paymentService: PaymentService,
    private log: AppLoggingService,
    private localization: Localization) {
  }


  ngOnInit() {
    this.dateString = this.localization.NorwegianDateFormat();
  }


  confirmOrder() {

    this.sessionManager.removeShoppingCartData();
    this.router.navigate(['paymentmessage']);
  }

}



// WEBPACK FOOTER //
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/src/app/payment-gateway/payment-receipt/payment-receipt.component.ts